import React, { Component } from 'react';
import { toast } from 'react-toastify';
import { Link } from 'react-router-dom';
import cookie from 'react-cookies';
import { API_URL } from '../../../constants';
import axios from 'axios';
import $ from 'jquery';
import { DropDownList } from '../../Elements/Select/dropdown';
import Moment from 'moment';
import ButtonLoader from '../../Elements/Button/button'; 

// Estilos del Modal (Idénticos a Add.js)
const modalStyles = {
    overlay: {
        position: 'fixed',
        top: 0,
        left: 0,
        width: '100%',
        height: '100%',
        backgroundColor: 'rgba(0,0,0,0.5)',
        zIndex: 9999,
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center'
    },
    content: {
        backgroundColor: '#fff',
        width: '90%',
        maxWidth: '1000px',
        height: '85%',
        maxHeight: '600px',
        borderRadius: '4px',
        padding: '0', 
        display: 'flex',
        flexDirection: 'column',
        boxShadow: '0 4px 8px rgba(0,0,0,0.2)'
    },
    header: {
        padding: '20px',
        borderBottom: '1px solid #eee',
        backgroundColor: '#f8f9fa'
    },
    body: {
        flex: 1,
        overflowY: 'auto',
        padding: '20px'
    },
    footer: {
        padding: '15px 20px',
        borderTop: '1px solid #eee',
        textAlign: 'right',
        backgroundColor: '#f9f9f9'
    },
    closeBtn: {
        float: 'right',
        cursor: 'pointer',
        fontWeight: 'bold',
        fontSize: '20px',
        color: '#999'
    }
};

export default class EditEmailing extends Component {

    constructor(props) {
        super(props);

        this.state = {
            loading: true, 
            loadingData: true, // Bloquea validaciones de sector al inicio
            aprobador: false,
            emai_Id: 0,

            listaCategoriasRecurso: [], 
            
            resource: {
                Emai_Asunto: "",
                Emai_Sector: 0, 
                filtroCategoria: 0 
            },
            
            Emai_Anio: 0,
            Emai_Mes: 0,
            Emai_Estado: 0,

            Validacion: {
                Emai_Asunto: { Error: false }
            },
            
            security: cookie.load('user'),

            // --- ESTADOS POPUP MODAL (Copiados de Add.js) ---
            modalShow: false,
            modalRecursosData: [],
            modalLoading: false,
            sBuscarRecurso: "",       
            tempSelectedRecursos: [], 
            addedRecursos: [], 
            
            // Filtros internos del modal (Restaurados)
            filtroYYYY: 0,
            filtroMM: 0
        }

        this.handleInputChange = this.handleInputChange.bind(this);
        this.openModalRecursos = this.openModalRecursos.bind(this);
        this.closeModalRecursos = this.closeModalRecursos.bind(this);
        this.searchResource = this.searchResource.bind(this);
        this.handleCheckRecurso = this.handleCheckRecurso.bind(this);
        this.addSelectedRecursosToForm = this.addSelectedRecursosToForm.bind(this);
        this.removeRecursoFromForm = this.removeRecursoFromForm.bind(this);
        this.callButtonUpdate = this.callButtonUpdate.bind(this);
        this.handleClickCancel = this.handleClickCancel.bind(this);
        this.handlePreview = this.handlePreview.bind(this); 
    }

    componentDidMount() {
        if ($('#containerPanel').is("*")) { $('#containerPanel').hide(); }

        const { id } = this.props.match.params;
        this.setState({ emai_Id: id });

        // Cargar Categorias
        axios.get(`${API_URL}CategoryUX/15`).then(res => {
            if(res.data && res.data.result) this.setState({ listaCategoriasRecurso: res.data.result });
        });

        this.verificarSiEsAprobador();

        this.loadData(id);
    }

    loadData(id) {
        const url = `${API_URL}EmailingUX/${id}`;
        
        axios.get(url).then(response => response.data)
        .then((data) => {
            if (data.isSucess || data.statusCode === 200) {
                let item = Array.isArray(data.result) ? data.result[0] : data.result;

                if(!item) {
                    toast.error("No se encontraron datos.");
                    this.setState({ loading: false });
                    return;
                }

                // Mapeo seguro
                const mappedResource = {
                    Emai_Asunto: item.emai_Asunto || item.eMail_Asunto || "",
                    Emai_Sector: item.emai_Sector || item.eMail_Sector || 0,
                    filtroCategoria: 0
                };

                let recursosRecuperados = [];
                if (item.lEmailingRecursos && item.lEmailingRecursos.length > 0) {
                    recursosRecuperados = item.lEmailingRecursos;
                }

                this.setState({
                    resource: mappedResource,
                    Emai_Anio: item.emai_Anio || item.eMail_Anio || 0,
                    Emai_Mes: item.emai_Mes || item.eMail_Mes || 0,
                    Emai_Estado: item.emai_Estado || item.eMail_Estado || 0,
                    addedRecursos: recursosRecuperados,
                    loading: false
                    // IMPORTANTE: Retrasamos un poco el desbloqueo para asegurar que los DropDowns terminen de pintar
                }, () => {
                    setTimeout(() => {
                        this.setState({ loadingData: false });
                    }, 500);
                });

            } else {
                toast.error(data.StatusMessage || "Error al cargar datos.");
                this.setState({ loading: false });
            }
        })
        .catch(error => {
            console.error(error);
            this.setState({ loading: false });
        });
    }

    verificarSiEsAprobador() {
        const nUsuCodigo = this.state.security ? this.state.security.nUsuCodigo : null;

        if (!nUsuCodigo) {
        console.warn("No se encontró usuario autenticado en el state.");
        return;
        }

        const url = `${API_URL}ParameterUX/EMAILING_APROBADORS`;
        axios.get(url)
        .then(response => response.data)
        .then((data) => {
            if (data.isSucess && data.result && data.result.length > 0) {
                // ej  string: "25108,99096,172256"
                const sValor = data.result[0].sValor; 
                if (sValor) {
                    const listaAprobadores = sValor.split(',');
                    const esAprobador = listaAprobadores.includes(String(nUsuCodigo));
                    this.setState({
                        aprobador: esAprobador
                    }, () => {
                        console.log("Estado de aprobador actualizado:", this.state.aprobador);
                    });
                }
            }
        })
        .catch(error => {
            console.error('Error consultando ParameterUX/EMAILING_APROBADORS', error);
            this.setState({ aprobador: false });
        });
    }


    handlePreview(event) {
        if (event) event.preventDefault();
        
        const { emai_Id } = this.state;
        if (!emai_Id) {
            toast.warning("No se puede previsualizar sin un ID válido.");
            return;
        }

        toast.info("Generando previsualización...");
        this.setState({ loading: true });

        const url = `${API_URL}EmailingUX/DownloadHTML/${emai_Id}`;

        axios.get(url)
            .then(response => {
                this.setState({ loading: false });
                
                if (response.data && response.data.statusCode === 200 && response.data.result) {
                    const htmlContent = response.data.result.emai_HTML;
                    if (!htmlContent) {
                        toast.warning("El mailing no tiene contenido HTML para visualizar.");
                        return;
                    }
                    const blob = new Blob([htmlContent], { type: 'text/html;charset=utf-8' });
                    const blobUrl = window.URL.createObjectURL(blob);
                    setTimeout(() => 
                    {
                        window.open(blobUrl, '_blank');
                        window.URL.revokeObjectURL(blobUrl)
                    }
                    , 1000); 
                } else {
                    toast.error(response.data.statusMessage || "No se pudo obtener la previsualización.");
                }
            })
            .catch(error => {
                console.error("Error al previsualizar:", error);
                this.setState({ loading: false });
                toast.error("Error de comunicación al intentar previsualizar.");
            });
    
        }

    handleInputChange(event) {
        const target = event.target;
        let value = target.type === 'checkbox' ? target.checked : target.value;
        const name = target.name;

        if (value && typeof value === 'object' && value.value !== undefined) {
            value = value.value;
        }

        // Lógica de Sector: Solo validar si NO estamos cargando data inicial
        if (name === "Emai_Sector") {
            if (!this.state.loadingData && this.state.addedRecursos.length > 0) {
                if (value != this.state.resource.Emai_Sector) {
                    if (!window.confirm("Al cambiar de sector, se eliminarán los recursos seleccionados. ¿Seguro de continuar?")) {
                        return; 
                    } else {
                        this.setState({ addedRecursos: [] });
                    }
                }
            }
        }

        let copyResource = this.state.resource;
        copyResource[name] = value;

        this.setState({ resource: copyResource });
    }

    // =========================================================
    //  MODAL LÓGICA (Copiada de Add.js)
    // =========================================================

    openModalRecursos(e) {
        if(e) e.preventDefault();
        const sector = this.state.resource.Emai_Sector;
        if (!sector || sector == 0 || sector == "0") {
            toast.warning("Debe seleccionar un SECTOR antes de agregar recursos.");
            return;
        }
        this.setState({
            modalShow: true,
            sBuscarRecurso: "",
            tempSelectedRecursos: [],
            modalRecursosData: [],
            // Restauramos filtros
            filtroYYYY: 0, 
            filtroMM: 0
        });
    }

    closeModalRecursos() {
        this.setState({ modalShow: false });
    }

    searchResource(e) { 
        if (e) e.preventDefault();
        this.setState({ modalLoading: true });
        
        const page = '1';
        let search = this.state.sBuscarRecurso;
        const codUsuario = this.state.security.nUsuCodigo || 0; 
        if (!search || search === "") { search = "ALL"; }
        
        // Usamos los filtros del estado del modal (Igual que en Add.js)
        const anio = this.state.filtroYYYY || 0;
        const mes = this.state.filtroMM || 0;
        const nTipo = this.state.resource.filtroCategoria || 0;
        const sector = this.state.resource.Emai_Sector || 0;

        const url = `${API_URL}EmailingUX/GetRecursos/${page}/${codUsuario}/${sector}/${nTipo}/${anio}/${mes}/${search}`;

        axios.get(url).then(response => response.data)
        .then((data) => {
            if (!data.result || data.result.length === 0) {
                toast.warn("No se encontraron resultados");
            }
            this.setState({
                modalRecursosData: data.result || [],
                modalLoading: false
            });
        }).catch(error => {
            this.setState({ modalLoading: false });
            toast.error("Error al buscar recursos.");
        });
    }

    handleCheckRecurso(recurso) {
        let selected = [...this.state.tempSelectedRecursos];
        const exists = selected.find(r => r.nRecursoCodigo === recurso.nRecursoCodigo);
        if (exists) {
            selected = selected.filter(r => r.nRecursoCodigo !== recurso.nRecursoCodigo);
        } else {
            selected.push(recurso);
        }
        this.setState({ tempSelectedRecursos: selected });
    }

    addSelectedRecursosToForm() {
        if(this.state.tempSelectedRecursos.length === 0){
            toast.warning("Seleccione al menos un recurso.");
            return;
        }
        let currentAdded = [...this.state.addedRecursos];
        const newSelection = this.state.tempSelectedRecursos;
        
        // Evitar duplicados
        newSelection.forEach(newItem => {
            if (!currentAdded.find(existing => existing.nRecursoCodigo === newItem.nRecursoCodigo)) {
                currentAdded.push(newItem);
            }
        });
        
        this.setState({ addedRecursos: currentAdded, modalShow: false });
        toast.success("Recursos agregados correctamente.");
    }

    removeRecursoFromForm(idRecurso) {
        if(window.confirm("¿Está seguro de quitar este recurso de la lista?")){
            let currentAdded = this.state.addedRecursos.filter(r => r.nRecursoCodigo !== idRecurso);
            this.setState({ addedRecursos: currentAdded });
        }
    }

    callButtonUpdate(event) {
        if(event) event.preventDefault(); 

        let newState = this.state;
        if (!newState.resource.Emai_Asunto) { toast.warning("Ingrese el Asunto"); return; }
        if (!newState.resource.Emai_Sector || newState.resource.Emai_Sector == 0) { toast.warning("Seleccione un Sector"); return; }
        
        const estado = parseInt(newState.Emai_Estado);
        if ((estado === 2 || estado === 3) && newState.addedRecursos.length === 0) {
            toast.error("Para los estados 'Por Validar' o 'Validado' es obligatorio agregar recursos.");
            return;
        }

        this.setState({ loading: true });

        const url = `${API_URL}EmailingUX`; 
        const payload = {
            Emai_Id: newState.emai_Id,
            Emai_Asunto: newState.resource.Emai_Asunto,
            Emai_Sector: parseInt(newState.resource.Emai_Sector),
            Emai_Mes: parseInt(newState.Emai_Mes),
            Emai_Anio: parseInt(newState.Emai_Anio),
            // Emai_Usuario: newState.security.sUsuNombre || "Admin", 
            Emai_Usuario: this.state.aprobador == true ? newState.security.nUsuCodigo.toString() || "" : "",
            Emai_Estado: estado,
            Emai_UsuarioEdicion: newState.security.nUsuCodigo,
            sRecursos: (newState.addedRecursos || []).map(r => r.nRecursoCodigo).join(',')
        };

        const formData = JSON.stringify(payload);

        axios.put(url, JSON.stringify(formData), {
            headers: {'Content-Type': 'application/json; charset=UTF-8', 'Accept': 'application/json'}
        }).then((data) => {
            if (data.data.isSucess) {
                toast.success("Emailing actualizado exitosamente.");
                setTimeout(() => { this.props.history.push('/Emailing'); }, 1500);
            } else {
                toast.error(data.data.message || "Error al actualizar.");
                this.setState({ loading: false });
            }
        }).catch(() => {
            toast.error("Error de comunicación.");
            this.setState({ loading: false });
        });
    }

    handleClickCancel(e) {
        if(e) e.preventDefault();
        this.props.history.push('/Emailing'); 
    }

    // =========================================================
    //  RENDER MODAL (Copiado y adaptado de Add.js)
    // =========================================================
    renderModalContent() {
        if (!this.state.modalShow) return null;
        return (
             <div style={modalStyles.overlay}>
                <div style={modalStyles.content}>
                    <div style={modalStyles.header}>
                        <span style={modalStyles.closeBtn} onClick={this.closeModalRecursos}>×</span>
                        <h3 style={{margin: 0, color: '#666'}}>Buscador de recursos</h3>
                        
                        {/* FILTROS DE BÚSQUEDA RESTAURADOS */}
                        <div className="row mt-3">
                            <div className="col-md-3">
                                <label>Recurso</label>
                                <input type="text" className="form-control" placeholder="Título del recurso" value={this.state.sBuscarRecurso} onChange={(e) => this.setState({sBuscarRecurso: e.target.value})} />
                            </div>
                            <div className="col-md-3">
                                <label>Categoría</label>
                                <select className="form-control" name="filtroCategoria" value={this.state.resource.filtroCategoria || 0} onChange={this.handleInputChange}>
                                    <option value="0">-- Todas --</option>
                                    {this.state.listaCategoriasRecurso.map((cat, i) => <option key={i} value={cat.crec_Id}>{cat.crec_Nombre}</option>)}
                                </select>
                            </div>
                            
                            {/* Filtro Año y Mes restaurados */}
                            <div className="col-md-4">
                                <label>Fecha publicación</label>
                                <div className="d-flex" style={{ display: 'flex' }}>
                                    <select className="form-control form-control-sm w-50 mr-2" style={{ marginRight: '5px' }} value={this.state.filtroYYYY} onChange={(e) => this.setState({filtroYYYY: e.target.value})}>
                                        <option value="0">Año</option>
                                        {[...Array(5)].map((_, i) => { const y = new Date().getFullYear() - i; return <option key={y} value={y}>{y}</option>; })}
                                    </select>
                                    <select className="form-control form-control-sm w-50" value={this.state.filtroMM} onChange={(e) => this.setState({filtroMM: e.target.value})}>
                                        <option value="0">Mes</option>
                                        {[...Array(12).keys()].map((m) => (<option key={m+1} value={m+1}>{m+1}</option>))}
                                    </select>
                                </div>
                            </div>

                            <div className="col-md-2 d-flex align-items-end">
                                <button className="btn btn-primary btn-block" onClick={this.searchResource}><i className="fa fa-search"></i> BUSCAR</button>
                            </div>
                        </div>
                    </div>

                    <div style={modalStyles.body}>
                        {this.state.modalLoading ? <div className="text-center p-4"><i className="fas fa-spinner fa-spin fa-2x"></i> Cargando...</div> : 
                        <table className="table table-bordered table-striped">
                            <thead style={{backgroundColor: '#4a90e2', color: 'white'}}>
                                <tr>
                                    <th>Título del recurso</th>
                                    <th>Categoría</th>
                                    <th>Fecha publicación</th>
                                    <th className="text-center" style={{width:'50px'}}></th> 
                                </tr>
                            </thead>
                            <tbody>
                                {this.state.modalRecursosData.map((item, idx) => {
                                    const isChecked = this.state.tempSelectedRecursos.some(r => r.nRecursoCodigo === item.nRecursoCodigo);
                                    return (
                                        <tr key={idx}>
                                            <td>{item.sTitulo}</td>
                                            <td>{item.sDescripcionTipoRecurso}</td>
                                            <td>{Moment(item.dFechaPublicacion).format('YYYY-MM-DD')}</td>
                                            <td className="text-center">
                                                <input 
                                                    type="checkbox" 
                                                    checked={isChecked} 
                                                    onChange={() => this.handleCheckRecurso(item)}
                                                     style={{
                                                                transform: 'scale(1.5)', 
                                                                cursor: 'pointer',
                                                                WebkitAppearance: 'checkbox',
                                                                MozAppearance: 'checkbox',
                                                                appearance: 'checkbox',
                                                                display: 'inline-block' 
                                                            }}
                                                />
                                            </td>
                                        </tr>
                                    )
                                })}
                                {this.state.modalRecursosData.length === 0 && <tr><td colSpan="4" className="text-center">No hay resultados para mostrar</td></tr>}
                            </tbody>
                        </table>}
                    </div>
                    <div style={modalStyles.footer}>
                        <button 
                            className="btn btn-danger" 
                            style={{backgroundColor: '#c0392b', fontWeight: 'bold'}}
                            onClick={this.addSelectedRecursosToForm}
                        >
                            Añadir recurso(s)
                        </button>
                    </div>
                </div>
            </div>
        );
    }

    render() {
        return (
            <div className="">
                {/* {(this.state.loading && !this.state.loadingData) && <div className="loader"></div>} */}
                {this.renderModalContent()}

                <div className="divContenedorBreadcrumbs">
                    <div className="divCenterBreadcrumbs">
                        <img src="/static/images/icoBreadcrumb.png" alt="" />
                        <a href="/"> / Panel de Configuración General </a>
                        <Link to="/administradores"> / Administradores </Link>
                        <Link to="/Emailing"> / Emailing </Link>
                        <span> / Editar </span>
                    </div>
                </div>
                <div className="divTitulo_Panel">Editar Emailing</div>

                <div className="div_Modulos_Noticias">
                    
                    {/* ASUNTO */}
                    <div className="txtFile x-1">
                        <label>Asunto:</label>
                        <input type="text" placeholder="Asunto" name='Emai_Asunto' value={this.state.resource.Emai_Asunto} maxLength={1000} onChange={this.handleInputChange} />
                    </div>
                    
                    {/* AÑO y MES */}
                    <div className="x-2 relative anio">
                        <label>Año:</label>
                        <select name="Emai_Anio" value={this.state.Emai_Anio} onChange={(e) => this.setState({ Emai_Anio: e.target.value })}>
                            <option value="0">Año</option>
                            {[...Array(3)].map((_, i) => {
                                const year = new Date().getFullYear() + i;
                                return <option key={year} value={year}>{year}</option>;
                            })}
                        </select>
                    </div>

                    <div className="txtFile x-2 mes">
                        <label>Mes:</label>
                        <select name="Emai_Mes" value={this.state.Emai_Mes} onChange={(e) => this.setState({ Emai_Mes: e.target.value })}>
                            <option value="0">Mes</option>
                            {[...Array(12).keys()].map((m) => (<option key={m + 1} value={m + 1}>{new Date(0, m).toLocaleString('es', { month: 'long' })}</option>))}
                        </select>
                    </div>

                    {/* SECTOR - Bloqueado visualmente mientras carga data */}
                    <div className="txtFile x-1">
                        <label>Sector:</label>
                        {this.state.loadingData ? <div className="alert alert-info py-1">Cargando datos...</div> : 
                            <DropDownList
                                key={this.state.resource.Emai_Sector} 
                                name="Emai_Sector" 
                                id="Emai_Sector"
                                componente={"Sector"}
                                valor={this.state.resource.Emai_Sector}
                                onChange={this.handleInputChange}
                            />
                        }
                    </div>

                    {/* RECURSOS */}
                    <div className="txtFile x-1" style={{border: '1px dashed #ccc', padding: '15px', marginTop:'15px', borderRadius: '5px', backgroundColor: '#fdfdfd'}}>
                        <div className="d-flex justify-content-between align-items-center">
                            <label><strong>Recursos seleccionados:</strong></label>
                            <button type="button" onClick={this.openModalRecursos} className="btn btn-sm btn-primary" style={{fontWeight: 'bold'}}>
                                Agregar recurso...
                            </button>
                        </div>
                        
                        <table className="table table-sm table-bordered mt-2" style={{background: 'white'}}>
                            <thead><tr style={{background: '#eee'}}><th>Título</th><th>Categoría</th><th>Enlace</th><th style={{width:'50px'}}></th></tr></thead>
                            <tbody>
                                {this.state.addedRecursos.length > 0 ? this.state.addedRecursos.map((rec, i) => (
                                    <tr key={i}>
                                        <td>{rec.sTitulo}</td>
                                        <td>{rec.sDescripcionTipoRecurso}</td>                                              
                                        <td>
                                            {rec.sEnlaceDocumento ? (
                                                <a href={rec.sEnlaceDocumento} target="_blank" rel="noopener noreferrer" style={{ color: '#007bff', textDecoration: 'underline' }}>Ver</a>
                                            ) : <span>-</span>}
                                        </td>
                                        <td className="text-center">
                                            {/* TACHITO ROJO RESTAURADO */}
                                            <i 
                                                className="fa fa-trash" 
                                                title="Quitar recurso"
                                                style={{color: 'red', cursor: 'pointer', fontSize: '18px', fontFamily: 'FontAwesome'}} 
                                                onClick={() => this.removeRecursoFromForm(rec.nRecursoCodigo)}
                                            ></i>
                                        </td>
                                    </tr>
                                )) : <tr><td colSpan="4" className="text-center text-muted">Sin recursos seleccionados</td></tr>}
                            </tbody>
                        </table>
                    </div>
                    
                    {/* ESTADO */}
                    <div className="txtFile x-1">
                        <div className="form-group">
                            <label htmlFor="Emai_Estado" className='h6'>
                                <strong>Estado <span className='font-weight-bold text-danger ml-2'>*</span></strong>
                            </label>
                            <div className="">
                                <select name="Emai_Estado" className="form-control form-control-sm w-50" value={this.state.Emai_Estado} onChange={(e) => this.setState({ Emai_Estado: e.target.value })}>
                                    <option value="0">Seleccione</option>
                                    <option value="1">Borrador</option>
                                    <option value="2">Por validar</option>
                                    {this.state.aprobador && (
                                    <option value="3">Validado</option>
                                    )}                                    
                                </select>
                            </div>
                        </div>
                    </div>

                    {/* BOTONES */}
                    <div className="divContenedorBtn_Noticias">

                        <button className="btn btn-secondary ml-3" onClick={this.handlePreview} title="Ver cómo quedará el emaling"
                            style={{'background': '#035493'}} >Previsualizar</button>
                         &nbsp;&nbsp;
                        <ButtonLoader 
                            text=" GUARDAR " 
                            textProcessing="GUARDANDO..." 
                            loading={this.state.loading && !this.state.loadingData} 
                            callFunctionButton={(e) => this.callButtonUpdate(e)}
                        />
                        <button className="btn btn-secondary ml-2" onClick={this.handleClickCancel}>Cancelar</button>
                    </div>
                </div>
            </div>
        )
    }
}